import { HostListener, Component, OnInit, Input, SimpleChanges, ViewChild, Renderer2, AfterViewInit, Output, EventEmitter, ElementRef, OnDestroy, OnChanges } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SharedPoint, TimeSeriesDetail } from 'src/app/models/dashboard';
import { ElapsedTimeService } from '../../../service/elapsed-time.service';
import { Zone, SiteParameter, SiteTwin } from 'src/api/models';
import { ApplicationConfig } from 'src/app/models/config';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { FireService } from 'src/service/fire.service';
import { FireForesightService } from 'src/api/services';

interface PreviousLightStackElement {
  key: string;
  element: Element;
}

@Component({
  selector: 'app-fire-camera-viewer',
  templateUrl: './fire-camera-viewer.component.html',
  styleUrls: ['./fire-camera-viewer.component.css']
})
export class FireCameraViewer implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('imageSource') imageSource: ElementRef;
  @ViewChild('mainimage') mainimage: ElementRef;

  @ViewChild('livestream') private livestream: ElementRef<HTMLImageElement>;

  @Input() showZones: boolean;
  public _zones: Zone[];
  public _allZones: Zone[];
  @Input() set zones(zones: Zone[]){
    this._allZones = zones;
    if (this._allZones == null){
      this._zones = null;
    } else {
      this._zones = this._allZones.filter(z => z.cameraBearing == this.objects[this.selectedImageIndex].bearing);
    }
  }
  
  
  @HostListener('document:keypress', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    console.log("KEY", event);
    
    //var index = sorted.
    if (event.key == 'a'){
      if (this.selectedImageIndex <= 0){
        this.selectedImageIndex = this.objects.length - 1;
      } else {
        this.selectedImageIndex = this.selectedImageIndex - 1;
      }
    }
    else if (event.key == 's'){
      if (this.selectedImageIndex >= this.objects.length - 1){
        this.selectedImageIndex = 0;
      } else {
        this.selectedImageIndex = this.selectedImageIndex + 1;
      }
    }
    this.showImage(this.selectedImageIndex);
  }
   
  @Input() siteTwin: SiteTwin;
  @Input() fireSelection: boolean = false;
  @Input() fullScreen: boolean = false;
  @Input() autoRotate: boolean = false;
  @Input() offline: boolean = false;

  //selectedImageKey: string;
  selectedImageIndex: number;
  keys: string[];
  objects: SiteParameter[];

  @Output() onBearingChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() onImageChange: EventEmitter<number> = new EventEmitter<number>();

  //selectedImage: SharedPoint[];
  
  constructor(private renderer:Renderer2, 
    private elapsedTimeService:ElapsedTimeService, 
    public app: ApplicationConfigService,
    private svc: FireForesightService,
    public fire: FireService) {
  }
  
  ngOnDestroy(): void {
    if (this.timer){
      clearInterval(this.timer);
    }
  }
  

  getSelectedImageOverlay(index){
    if (index == undefined){
      //key = Object.keys(this.siteTwin.parameters)[0]
      index = 0;
    }
    return this.objects[index]?.analysis;
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.siteTwin && this.siteTwin.siteUri != this.fire.camera?.siteUri){
      this.liveStreaming = false;
      this.streamUrl = null;
      this.timeout = 0;
      if (this.streamTimeout){
        clearTimeout(this.streamTimeout);
      }
      this.fire.getCameraByUri(this.siteTwin.siteUri, c => {
        // do nothing
        console.log("FireCameraViewer ngOnChanges loaded camera", c);
      });
    }
  }

  timer: any;
  ngOnInit(): void {
    if (this.siteTwin){
      this.refresh(this.siteTwin);
    }
    if (this.autoRotate && !this.offline){
      this.timer = setInterval(() => this.moveNext(), 10000)
    }    
  }

  mode: number = 0;
  changeMode(mode: number) {
    if (this.mode == mode) {
      // this is a toggle back to the previous mode
      this.mode = 0;
      this.stopStream();
      return;
    }
    this.mode = mode;
    if (mode == 0) {
      // normal mode
      this.stopStream();
    }
    else if (mode == 2) {
      // live mode
      this.liveStream();
    }
  }

  liveStreaming: boolean;
  streamUrl: string;
  streamTimeout;
  timeout: number = 0;

  liveStream() {
   
    if (this.streamTimeout != null) {
      clearTimeout(this.streamTimeout);
      this.timeout = 0;
    }

    if (this.liveStreaming) {
      this.stopStream();
      //this.streamUrl = this.fire.camera?.manualCameraLatestUrl;
    } else {
      var cameraId = this.fire.camera?.siteId;
      if (cameraId == null) {
        return;
      }
      //this.streamUrl = "/assets/images/connecting.png";
      this.svc.FireForesightGetStreamKey({ customerId: this.app.customerId, siteId: cameraId }).subscribe(streamKey => {
        const finalStreamUrl = `/api/FireForesight/GetSecureStream/${streamKey}`;
        this.streamUrl = finalStreamUrl;
        this.streamTimeout = setInterval(() => {
          if (this.timeout >= 100) {
            this.liveStream();
            //this.toasterService.success("Video Feed Timed Out");
            clearTimeout(this.streamTimeout);
            this.timeout = 0;
            setTimeout(() => {
              this.liveStreaming = false
              this.stopStream();
              this.mode = 0;
            }, 1000);
          } else {
            this.timeout = this.timeout + 0.25;
          }
        }, 200);
      }, err => {
        this.liveStreaming = false;
        console.error("FireForesightGetStreamKey error:", err);
        this.streamUrl = null;
      });
    }

    this.liveStreaming = !this.liveStreaming;

    // todo: issue command to redirect camera in the direction of the incident

    //this.streamUrl = '/api/FireForesight/GetStream/' + this.app.customerId + '/' + this.fire.camera?.siteId;
    //this.liveStreaming = !this.liveStreaming;
  }

  private stopStream(): void {
    // Explicitly clear the image src to stop the browser from loading the stream
    if (this.livestream && this.livestream.nativeElement) {
      this.livestream.nativeElement.src = '';
    }
    this.streamUrl = null;
    this.liveStreaming = false;
  }

  enableFireSelection(){
    this.fireSelection = true;
    
  }

  moveNext(){
    if (this.selectedImageIndex >= this.objects.length - 1){
      this.selectedImageIndex = 0;
    } else {
      this.selectedImageIndex = this.selectedImageIndex + 1;
    }
    this.showImage(this.selectedImageIndex);
  }

  refresh(twin: SiteTwin): void {
    this.siteTwin = twin;
    this.selectedImageIndex = 0;//Object.keys(this.siteTwin.parameters)[0]
    //console.log(this.siteTwin.parameters[this.selectedImageKey
    if (this.siteTwin && this.siteTwin.parameters){
      this.keys = Object.keys(this.siteTwin.parameters);
      var params = Object.values(this.siteTwin.parameters);
      this.objects = params
        .filter(a => !a.hidden && a.bearing >= 0 && a.latestValue)
        .sort((a, b) => a.bearing - b.bearing);
      console.log(this.objects);
      this.showImage(this.selectedImageIndex);
    }
  }

  ngAfterViewInit() {
    this.selectedImageIndex = 0;//Object.keys(this.siteTwin.parameters)[0]
  }

  showImage(index){
    this.selectedImageIndex = index;
    var param = this.objects[this.selectedImageIndex];
    if (this._allZones == null){
      this._zones = null;
    }else{
      this._zones = this._allZones.filter(z => z.cameraBearing == this.objects[this.selectedImageIndex].bearing);
    }
    if (this.onImageChange){
      this.onImageChange.emit(param.bearing);
    }
  }

  public showLineAt: any;
  pointerEvent(event){
    if (event && this.onBearingChange){
      var step = this.siteTwin.metaData["fieldOfView"] ? parseInt(this.siteTwin.metaData["fieldOfView"]) : (360 / this.objects.length);
      if (this.objects[this.selectedImageIndex].fieldOfView){
        step = this.objects[this.selectedImageIndex].fieldOfView
      }
      const param = this.objects[this.selectedImageIndex];
      const fov = step;//param.fieldOfView ?? 36;
      const min = param.bearing - (fov/2);
      const max = param.bearing + (fov/2);
      const mov = event.x * fov / 100;
      const bearing = min + mov;
      const bearingNormalized = (bearing + 360) % 360;
      this.showLineAt = { percent: event.x, deg: Math.round(bearingNormalized) };
      this.onBearingChange.emit(bearingNormalized);
    }
  }


}
